import {
  call, takeEvery,
} from 'redux-saga/effects';
import { getOrderTrackerRequest } from './requests/orderTracker';
import {
  FETCH_ORDER_TRACKER_REQUESTS,
} from '../actions';

export function* orderTracker(): Generator {
  yield call(getOrderTrackerRequest);
}

export function* watchOrderTracker(): Generator {
  yield takeEvery(FETCH_ORDER_TRACKER_REQUESTS, orderTracker);
}
